module.exports = __webpack_public_path__ + "static/case2_allergy_desktop-824b19faff6fa6f0a2c1925c379f2fb3.png";